/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * An internal helper that allows checking whether a component has been rendered with the specified `key` value.
 *
 * See: https://github.com/ckeditor/ckeditor5-builder/issues/1106.
 */
export function getRenderKey( chunks: Array<unknown> ): string {
	return chunks.join( '-' );
}
